import { Typography } from "@circle-react-shared/uikit/Typography";
import { Row as RowSkeleton } from "@circle-react-uikit/SkeletonLoader/components/Row";
import { formatPaywallCurrencyAmount } from "@circle-react/helpers/paywalls/currencies";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";

import { usePricePreviewContext } from "../../PricePreviewProvider";

interface DiscountLineProps {
  className?: string;
}

export const DiscountLine = ({ className }: DiscountLineProps) => {
  const { previewMutation } = usePricePreviewContext();

  const preview = previewMutation.data;

  if (!preview || previewMutation.isPending) {
    return <RowSkeleton lg className={className} />;
  }

  if (preview.first_payment.discount >= 0 || preview.trial_period?.free) {
    return null;
  }

  const amountDiscounted = formatPaywallCurrencyAmount(
    preview.currency,
    preview.first_payment.discount * -1,
  );

  return (
    <div
      className={classNames(
        "text-right first:w-full first:text-right",
        className,
      )}
    >
      <Typography.LabelXs weight="medium" color="text-green-success">
        {t("total_savings_today", {
          formatted_discount: amountDiscounted,
        })}
      </Typography.LabelXs>
    </div>
  );
};
